import { actions, createAction } from '@kanda-libs/ks-frontend-services';
import { CreatePageArgs } from '@kanda-libs/ks-frontend-services/src/middleware/helpers';
import Pages from 'pages';
import { RootState } from 'store';

export const ENQUIRY_INITIAL_ACTIONS: Omit<
  CreatePageArgs<RootState>,
  'path'
> = {
  PageComponent: Pages.Enquiry,
  requiredRoles: [],
  loadingDependencies: [],
  initialDataActions: [createAction(actions.getInfoEnquiry, {}, true)],
  idRequired: true,
};
